import { LabradorComponent } from '@/types/component';
import { pathToComponent, withDebugMetadata } from 'lib/utils';
import { standaloneComponent } from 'modules/dynamic-components';

const LabradorSlider: LabradorComponent = ({ type, data, meta }) => {
  const componentName = 'ElementSlider' + (pathToComponent(meta.path) || 'Swiper');
  const SliderComponent = standaloneComponent(componentName);

  return <SliderComponent {...data} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorSlider;
